export default [
  { label: "Status", value: "status" },
  { label: "Numero da NF", value: "number" },
  { label: "Numero Serial", value: "serial" },
  { label: "Data de emissão", value: "issued_at" },
  { label: "Data de cancelamento", value: "canceled_at" },
  { label: "Ações", value: "actions", className: "w-9" },
];
